import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/Info";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { infoTypes } from "./info.helper.constant";
import { ContentWrapper, IconWrapper, SpacedPaper } from "./styles";

export const InfoHelper = ({ children, type, elevation }) => {
  const [color, setColor] = useState();
  const [typename, setTypename] = useState();

  useEffect(() => {
    const infoType = infoTypes[type];
    if (type && infoType) {
      setTypename(infoType.name);
      setColor(infoType.color);
    }
  }, [type]);

  const getIcon = () => {
    switch (typename) {
      case "warning":
        return <ErrorOutlineIcon />;
      case "informations":
      default:
        return <InfoIcon />;
    }
  };

  return (
    <SpacedPaper spaced elevation={elevation || 0}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
        }}
      >
        {typename && <IconWrapper color={color}>{getIcon()}</IconWrapper>}
        <ContentWrapper color={color}>{children}</ContentWrapper>
      </Box>
    </SpacedPaper>
  );
};
